import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    NavLink,
    useHistory, useRouteMatch,
} from 'react-router-dom';
import { Icon } from "Icon";
import ProfileMenu from "components/ProfileMenu"

export default function Header() {
    const history = useHistory();
    const isTrackPage = useRouteMatch('/collection/tracks')

    return (
        <div className="flex w-full absolute top-0 left-0 h-15 px-8 items-center justify-between">

            <nav className="flex gap-x-4 items-center">
                <button className="text-white flex items-center justify-center w-8 h-8 rounded-full bg-black bg-opacity-70" disabled={history.length === 0} onClick={() => history.goBack()}>
                    <Icon src="prev" size={22} />
                </button>
                <button className="text-white flex items-center justify-center w-8 h-8 rounded-full bg-black bg-opacity-70" disabled={history.length === 0} onClick={() => history.goForward()}>
                    <Icon src="next" size={22} />
                </button>
                <Switch>
                    <Route path="/search">
                        <form className="block relative">
                            <Icon src="search" className="text-black absolute top-0 left-0 h-full w-12 flex items-center justify-center" />
                            <input type="text" autoFocus={true} placeholder="Artists, songs, or podcasts" className="h-10 text-sm leading-10 placeholder-gray-500 w-96 outline-none text-black pl-12 pr-4 rounded-full" />
                        </form>
                    </Route>
                    {!isTrackPage && (
                        <Route path="/collection">
                            <nav className="flex gap-x-2 ml-6">
                                <NavLink to="/collection/playlists" exact activeClassName="bg-white bg-opacity-10 shadow-lg" className="text-sm h-10 flex items-center px-4 rounded font-semibold">
                                    Playlists
                                </NavLink>
                                <NavLink to="/collection/podcasts" exact activeClassName="bg-white bg-opacity-10 shadow-lg" className="text-sm h-10 flex items-center px-4 rounded font-semibold">
                                    Podcasts
                                </NavLink>
                                <NavLink to="/collection/artists" exact activeClassName="bg-white bg-opacity-10 shadow-lg" className="text-sm h-10 flex items-center px-4 rounded font-semibold">
                                    Artists
                                </NavLink>
                                <NavLink to="/collection/albums" exact activeClassName="bg-white bg-opacity-10 shadow-lg" className="text-sm h-10 flex items-center px-4 rounded font-semibold">
                                    Albums
                                </NavLink>
                            </nav>
                        </Route>
                    )}
                </Switch>
            </nav>

            <ProfileMenu />

        </div>
    )
}
